import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NavItem } from "../model/nav-item";
import { CurrentUserService } from "./current-user.service";
import { CookieService } from "angular2-cookie/services/cookies.service";

@Injectable()
export class NavigationService {

    _navItems: Array<NavItem> = new Array<NavItem>();
    hashPrefix: string = '#!';
    hideMchNavigation$: BehaviorSubject<boolean> = new BehaviorSubject(location.href.includes('new-quote') ? true : false);

    user;

    constructor(
        private currentUserService: CurrentUserService,
        private cookieService: CookieService,
    ) {
        this.currentUserService.currentUser$.subscribe(x => this.user = x);
    }

    getNavItems() {
        const partnerPortalRedirectUrl = this.cookieService.get('PartnerPortalRedirectUrl');
        
        if ((!this.user.currentRetailer && this.user.currentRetailer.webEnabled) || this.user.roles.find(x => x === 'Sales_Leads_Claim' || x === 'Sales_Leads_Viewer')) {
            this._navItems.push(new NavItem('Leads', `${this.hashPrefix}/sales/leads`, 'fa fa-road', 'yeti-app-badge-sales'));
        }
    
        if (this.user.roles.find(x => x === 'Prospects_User') && !this.user.isInternal) 
            this._navItems.push(new NavItem('Prospects', `/crm/web/prospects`, 'yeti-icon-prospect', 'yeti-app-badge-sales', '_self'));
    
        if (this.user.roles.find(x => x === 'Sales_User') || this.user.roles.find(x => x === 'Sales_Viewer')) {
            this._navItems.push(new NavItem('Quotes', `${this.hashPrefix}/sales/quotes`, 'fa fa-file-text-o', 'yeti-app-badge-sales'));
            this._navItems.push(new NavItem('Orders', `${this.hashPrefix}/sales/orders`, 'fa fa-key', 'yeti-app-badge-sales'));
        }

        if (this.user.roles.find(x => x === 'FndPlannerModels') || this.user.roles.find(x => x === 'FndPlannerOrders') || this.user.roles.find(x => x === 'FndPlannerWizard')) {
            const link = this.generateAwsLink(`fndplanner`);
            this._navItems.push(new NavItem('Foundation Planner', link, 'fa fa-cubes', 'yeti-app-badge-service', '_self'));
        }
    
        if (this.user.roles.find(x => x === 'Sales_User') || this.user.roles.find(x => x === 'Sales_Viewer') || this.user.roles.find(x => x === 'Service_User') || this.user.roles.find(x => x === 'Warranty_User')) {
            this._navItems.push(new NavItem('Inventory', `${this.hashPrefix}/inventorymanagement/web`, 'fa fa-archive', 'yeti-app-badge-sales', '_self'));
        }
        if (this.user.roles.find(x => x === 'Warranty_User') || this.user.roles.find(x => x === 'Home_Owner_Viewer') || this.user.roles.find(x => x === 'Service_User')) {
            this._navItems.push(new NavItem('My Homeowners', `${this.hashPrefix}/service/myhomeowners`, 'fa fa-users', 'yeti-app-badge-service'));
        }
    
        if (this.user.roles.find(x => x === 'Service_User') || this.user.roles.find(x => x === 'Service_Viewer')) {
            this._navItems.push(new NavItem('Service & Parts', `${this.hashPrefix}/service`, 'fa fa-wrench', 'yeti-app-badge-service'));
        }
            
        if (!this.user.currentRetailer || this.user.roles.find(x => x === 'Nps_Viewer')) {
            this._navItems.push(new NavItem('NPS', `${this.hashPrefix}/nps`, 'fa fa-bar-chart-o', 'yeti-app-badge-nps'));
        }
    
        if (this.user.roles.find(x => x === 'Service_User') || this.user.roles.find(x => x === 'Service_Viewer') || this.user.roles.find(x => x === 'Sales_User') || this.user.roles.find(x => x === 'Sales_Viewer')) {
            this._navItems.push(new NavItem('Reports', `${this.hashPrefix}/reports`, 'fa fa-folder-open-o', 'yeti-app-badge-other'));
        }
    
        this._navItems.push(new NavItem('Learn', `${this.hashPrefix}/learn`, 'built-image', 'yeti-app-badge-other'));
        this._navItems.push(new NavItem('My Facilities', `${this.hashPrefix}/myfacilities`, 'fa fa-building', 'yeti-app-badge-other'));
        this._navItems.push(new NavItem('Help', `${this.hashPrefix}/help`, 'fa fa-question', 'yeti-app-badge-other'));
        this._navItems.push(new NavItem('Feedback', `https://claytonhomes.az1.qualtrics.com/SE/?SID=SV_bQadmwlrZeJ8EWF`, 'fa fa-comments-o', 'yeti-app-badge-other', '_blank'));
    
        return this._navItems;    
    }

    private checkForUserInRole(...roles: string[]): boolean {
        const user = this.user;
        return roles.some((role) => user.hasRole(role));
    }

    private generateAwsLink(app: string) {
        const { host, protocol } = window.location;
        const urlRegex = /(dev\.|itg\.|qua\.)*cmhconnection\.com/;
        const matches = host.match(urlRegex);

        let site: string;
        if (!matches) {
            // Local Host
            site = 'dev.cmhconnection.com';
        } else {
            site = matches[0];
        }

        return `${protocol}//${app}.${site}`;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/navigation.service.ts